import { writable } from 'svelte/store';
import { REQUEST_STATUS } from './common';
// const BASE_URL = '/api/v1'
// const BASE_URL_WS = `wss://${window.location.host}/api/v1`
// const BASE_URL = 'https://api.scanlab-dev.jotio.cloud/api/v1'
// const BASE_URL_WS = 'wss://api.scanlab-dev.jotio.cloud/api/v1'
const BASE_URL = 'https://api.scanlab.cloud/api/v1';
const BASE_URL_WS = 'wss://api.scanlab.cloud/api/v1';
/* const BASE_URL = 'http://localhost:1880/api'
const BASE_URL_WS = 'ws://localhost:1880/api' */
/* const BASE_URL = 'https://scanlab.jotio.cloud/api'
const BASE_URL_WS = 'wss://scanlab.jotio.cloud/api' */
function generateDataLoader(baseUrl, baseUrlWS) {
    return {
        get: (url) => {
            return fetch(baseUrl + url);
        },
        postJson: async (url, data) => {
            const raw = await fetch(baseUrl + url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
            });
            console.log('Incomming request', url, raw);
            const ret = await raw.json();
            return ret;
        },
        getStream: async (url) => {
            // throw Error('DEV MODE'); // MOCK
            return new Promise((res, rej) => {
                const socket = new WebSocket(baseUrlWS + url);
                socket.onopen = () => {
                    res(socket);
                };
                socket.onerror = (error) => {
                    console.error('sokcet error: ', error);
                    rej(error);
                };
            });
        },
        getToken: async (name, password) => {
            try {
                const raw = await fetch(baseUrl + '/gettoken ', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        name,
                        password
                    }),
                });
                const body = await raw.json();
                console.log('[INFO - New Token]:', body);
                setToken(body.jwt); /// TODO
                return {
                    json: {
                        jwt: body.jwt,
                        userInformation: body.userInformation
                    },
                    success: true,
                    status: REQUEST_STATUS.ok
                };
            }
            catch (err) { // TODO diff err msg
                return {
                    json: null,
                    success: false,
                    status: REQUEST_STATUS.cannotSend
                };
            }
        }
    };
}
function generateAuthDataLoader(baseUrl) {
    let token = null;
    let headder;
    const postFun = (url, pld) => {
        return fetch(baseUrl + url, {
            method: 'POST',
            headers: headder,
            body: JSON.stringify(pld),
        });
    };
    const postAndParseJson = async (url, pld) => {
        try {
            const raw = await postFun(url, pld);
            if (raw.status !== 200) {
                return {
                    json: null,
                    success: false,
                    status: REQUEST_STATUS.wrongStatus
                };
            }
            const json = await raw.json();
            return {
                json: json,
                success: true,
                status: REQUEST_STATUS.ok
            };
        }
        catch (err) { // TODO diff err msg
            return {
                json: null,
                success: false,
                status: REQUEST_STATUS.cannotSend
            };
        }
    };
    return {
        updatetoken: (newToken) => {
            if (newToken) {
                token = newToken;
                headder = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + newToken
                };
            }
            else {
                token = null;
                headder = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                };
            }
        },
        hasToken: () => {
            return token !== null;
        },
        dataLoader: {
            post: postFun,
            postJson: postAndParseJson,
            // postJson: async (_, __) => {
            // return null;
            // },
            loadJson: (pld) => {
                return postAndParseJson(pld, {});
            },
        }
    };
}
const dataLoader = generateDataLoader(BASE_URL, BASE_URL_WS);
const authDataLoader = generateAuthDataLoader(BASE_URL);
export function getAuthDataLoader() {
    return authDataLoader.dataLoader;
}
export function setToken(newToken) {
    authDataLoader.updatetoken(newToken);
}
export function getDataLoader() {
    return dataLoader;
}
export function generateMesageObservable(url) {
    const { subscribe, set, } = writable(null);
    const subscriptions = [];
    const obs = {
        subscribe: (runner) => {
            const destr = subscribe(runner);
            subscriptions.push(destr);
            return destr;
        },
        /* push: (data) => {
            set(data);
        } */
    };
    connectMesageObservable(url, (msg) => {
        set(msg.data);
    });
    /* dataLoader.getStream(url)
        .then(socket => {
            socket.onmessage = (data => {
                set(data.data);
            })
        }) */
    return obs;
}
async function connectMesageObservable(url, newDataHandle) {
    const reconnect = async () => {
        const openedSocket = await getDataLoader().getStream(url);
        console.log(`Connection to ${url} is opened`);
        if (openedSocket.readyState !== 1) {
            throw new Error('Scoket not connected');
        }
        openedSocket.onmessage = (msg) => {
            newDataHandle(msg);
        };
        openedSocket.onclose = () => {
            console.log(`Connection to ${url} is closed`);
            reconnect();
            // TODO
        };
    };
    try {
        await reconnect();
    }
    catch (err) {
        console.warn("Socket connection failed.");
    }
}
